import { FieldNames } from 'app/models/fields/names';
import { REVERSE_LEAD_ONLY_LOAN_PURPOSE } from 'app/models/options/options';
import { Question } from 'app/models/types';
import { reverseQuestionByName } from 'app/models/questions/reverse';

/**
 * The questions that differ from the reverse form's. Everything else is the reverse form's question as is.
 */
const REVERSE_LEAD_ONLY_QUESTIONS: Question[] = [
  {
    ...reverseQuestionByName(FieldNames.reverseMortgageLoanPurpose),
    options : REVERSE_LEAD_ONLY_LOAN_PURPOSE,
    title   : 'What is your goal?',
  },
  {
    ...reverseQuestionByName(FieldNames.livingPropertyState),
    title : 'What state is the property in?',
  },
];

/**
 * Takes in an array of field names and returns an array of questions
 *
 * @param {string[]} [names=[]] Field names
 * @returns {Question[]} Questions matching field names
 */
export const reverseLeadOnlyQuestionsByName = (names: string[] = []): Question[] => {
  return names.map((name) => {
    return REVERSE_LEAD_ONLY_QUESTIONS.find((question) => question.name === name) ?? reverseQuestionByName(name);
  });
};
